// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1eBw1","rootMobile":"styles_rootMobile__1nIcx"};